export const ADDITIONAL_NOTES_OPTIONS = [
  { value: 'mornings', label: 'mornings' },
  { value: 'afternoons', label: 'afternoons' },
  { value: 'evenings', label: 'evenings' },
  { value: 'with food', label: 'with food' },
  { value: 'empty stomach', label: 'empty stomach' }
]
